module.exports = __webpack_public_path__ + "static/media/engine-large-second.8248611e.jpg";